/**
 * Single source of truth for the "Last updated" date shown on every public
 * legal / policy page. Update this one constant when the documents change.
 */
export const LEGAL_LAST_UPDATED = "July 30, 2026";

/** Arabic rendering of the same date, for RTL legal pages. */
export const LEGAL_LAST_UPDATED_AR = "30 يوليو 2026";
